module.exports = __webpack_public_path__ + "img/dubai.9f5d28e3.jpg";